export default "__VITE_ASSET__01cddb1e__"